import { render, staticRenderFns } from "./tradeDetail.vue?vue&type=template&id=c22a0406&scoped=true&"
import script from "./tradeDetail.vue?vue&type=script&lang=ts&"
export * from "./tradeDetail.vue?vue&type=script&lang=ts&"
import style0 from "./tradeDetail.vue?vue&type=style&index=0&id=c22a0406&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c22a0406",
  null
  
)

export default component.exports